import { useSelector } from 'react-redux';
import { getGtkmShowingErrorModal } from '../store/gtkm/selector';
import { getPreviousStep } from '../store/flow/selectors';
import { Step } from 'signup-constants/Step';
import { isEndpointStatusError } from '../store/http-responses/selectors';
import { EndpointKey } from '../http/EndpointKey';
import { getShowBreezeErrorModal } from '../store/flow/selectors';
import { useCurrentStep } from './useCurrentStep';
import { getShouldUseBreezeCompanyInfo } from '../utils/getShouldUseBreezeCompanyInfo';
import { isAssignedToGTKMExperiment } from '../utils/gtkm/isAssignedToGTKM';
export const useShowErrorModal = () => {
  const showGTKMErrorModal = useSelector(getGtkmShowingErrorModal);
  const previousStep = useSelector(getPreviousStep);
  const {
    currentStep
  } = useCurrentStep();
  const breezeEndpointError = useSelector(isEndpointStatusError(EndpointKey.BreezeCompanyInfo));
  const showBreezeErrorModal = useSelector(getShowBreezeErrorModal);
  const shouldUseBreezeCompanyInfo = getShouldUseBreezeCompanyInfo();
  const isAssignedToGTKM = useSelector(isAssignedToGTKMExperiment);
  const isPreviousStepCompanyDomain = previousStep === Step.CompanyDomain;
  const renderBreezeErrorModal = shouldUseBreezeCompanyInfo && currentStep === Step.Industry && breezeEndpointError && showBreezeErrorModal;
  const renderGTKMErrorModal = isAssignedToGTKM && isPreviousStepCompanyDomain && showGTKMErrorModal;
  return {
    showErrorModal: renderBreezeErrorModal || renderGTKMErrorModal
  };
};